// action
export const getSegment = (state, val) => {
  state.segments = val
}

export const listSegment = (state, val) => {
  state.lists = val
}

export const segmentForm = (state, val) => {
  state.segment = val
}
